import React from 'react';
import ActivateObject from '../../../common/poppers/ActivateObject';
import DeleteObject from '../../../common/poppers/DeleteObject';
import NewBankAccountNumber from '../../bankaccountnumber/NewBankAccountNumber';
import ModifyTaxType from './ModifyTaxType';
import TaxTransition from './TaxTransition';
import TaxTypeRow from './TaxTypeRow';

export const taxTypeActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Adónem módosítása",
        actionComponent: (props, close) => <ModifyTaxType {...props} close={close} />
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Adónem törlése",
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/taxtype'} comp={<TaxTypeRow {...props} />} />
    },
    {
        dataDialog: "new-bankaccount-dialog",
        title: "Bankszámlaszám hozzáadása",
        dialogTitle: "Bankszámlaszám hozzáadása",
        actionComponent: (props, close) => <NewBankAccountNumber {...props} close={close} />
    },
    {
        dataDialog: "active-dialog",
        title: "Aktiválás",
        dialogTitle: "Adónem aktiválása",
        canShow: (row) => !row.active,
        actionComponent: (props, close) => <ActivateObject {...props} close={close} path={'/api/taxtype/activate'} comp={<TaxTypeRow {...props} />} />
    },
    {
        dataDialog: "active-dialog",
        title: "Inaktiválás",
        dialogTitle: "Adónem inaktiválása",
        canShow: (row) => row.active,
        actionComponent: (props, close) => <ActivateObject {...props} close={close} path={'/api/taxtype/activate'} inactive={true} comp={<TaxTypeRow {...props} />} />
    },
    {
        dataDialog: "tax-transition",
        title: "Adónem átvezetés",
        dialogTitle: "Adónem átvezetése",
        actionComponent: (props, close) => <TaxTransition {...props} close={close} />
    },
]